import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/parametrizacao`

    return {
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}`)
        },
        saldoExame(queryParms) {
            return repository.get(`${baseUrl}/saldo-exame?${urlUtil.serialize(queryParms)}`)
        },
        getCotaExame(queryParms) {
            return repository.get(`${baseUrl}/cota-exame?${urlUtil.serialize(queryParms)}`)
        },
        getCotaLaboratorio(queryParms) {
            return repository.get(`${baseUrl}/cota-laboratorio?${urlUtil.serialize(queryParms)}`)
        },
        getCotaLaboratorioTransferencia(queryParms) {
            return repository.get(`${baseUrl}/cota-laboratorio-transferencia?${urlUtil.serialize(queryParms)}`)
        },
        getCotaLaboratorioUnidade(queryParms) {
            return repository.get(`${baseUrl}/cota-laboratorio-unidade?${urlUtil.serialize(queryParms)}`)
        },
        getCotaLaboratorioExame(queryParms) {
            return repository.get(`${baseUrl}/cota-laboratorio-exame?${urlUtil.serialize(queryParms)}`)
        },
        getCotaLaboratorioExameUnidade(queryParms) {
            return repository.get(`${baseUrl}/cota-laboratorio-exame-unidade?${urlUtil.serialize(queryParms)}`)
        },
        getListagemCotaLaboratorio(queryParms) {
            return repository.get(`${baseUrl}/listagem-cota-laboratorio?${urlUtil.serialize(queryParms)}`)
        },
        getExamesUnidadeSolicitante(queryParms) {
            return repository.get(`${baseUrl}/exame-unidade-solicitante?${urlUtil.serialize(queryParms)}`)
        },
        getUnidadeFaturamento(queryParms) {
            return repository.get(`${baseUrl}/unidade-faturamento?${urlUtil.serialize(queryParms)}`)
        },
        getLaboratorioFaturamento(queryParms) {
            return repository.get(`${baseUrl}/laboratorio-faturamento?${urlUtil.serialize(queryParms)}`)
        },
        saldoUnidadeSolicitante(queryParms) {
            return repository.get(`${baseUrl}/saldo-unidade-solicitante?${urlUtil.serialize(queryParms)}`)
        },
        lotacoes(queryParms) {
            return repository.get(`${baseUrl}/lotacao?${urlUtil.serialize(queryParms)}`)
        },
        exame: {
            autocomplete(queryParms = {}) {

                return repository.get(`${baseUrl}/autocomplete-exame?${urlUtil.serialize(queryParms)}`)
            },
        },
        list(queryParms) {

            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
    }
}
